import React from "react";

import { useCheckClassificationPreclinical } from "@FillInTableContainer/components/FillInTable/components/TableCreator/components/ClinicalTrialsTableCreator/hooks/useCheckClassificationPreclinical";
import { useHandleTableCreatorWrapperPositionInfo } from "@FillInTableContainer/shared/hooks/useHandleTableCreatorWrapperPositionInfo";
import { ArticleSectionType } from "@FillInTableContainer/types/fillInTable.types";

import FillInTableNavigation from "./components/FillInTableNavigation/FillInTableNavigation";
import { NAVIGATION_LIST } from "./constants/fillInTableNavigationList.constants";
import * as S from "./TableCreatorNavigationTableWrapper.style";

interface Props {
  classificationKey: ArticleSectionType;
  children: JSX.Element;
}

const TableCreatorNavigationTableWrapper = ({
  classificationKey,
  children,
}: Props) => {
  const { tableCreatorWrapperRef } = useHandleTableCreatorWrapperPositionInfo();

  // NOTE : Preclinical인 경우 Drug Profile 메뉴만 표출
  const { isPreclinical } = useCheckClassificationPreclinical();
  const currentNavigationList = isPreclinical
    ? NAVIGATION_LIST[classificationKey].filter(
        (item) => item.sectionKey === "Drug Profile",
      )
    : NAVIGATION_LIST[classificationKey];

  return (
    <S.TableCreatorWrapper>
      <FillInTableNavigation itemList={currentNavigationList} />
      <S.GroupTableWrapper ref={tableCreatorWrapperRef}>
        {children}
      </S.GroupTableWrapper>
    </S.TableCreatorWrapper>
  );
};

export default TableCreatorNavigationTableWrapper;
